import React, { useEffect, useState } from 'react';
import App from './App';

import { KonsolAuth0Provider } from './components/auth/KonsolAuth0Provider';
import { KonsolSnackbarProvider } from './components/alerts/KonsolSnackbarProvider';
import { AbortControllerProvider } from './contexts/AbortControllerContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { useAuth0 } from "@auth0/auth0-react"; // or your custom hook

export default function Konsol() {
  const [permissions, setPermissions] = useState([]);

  return (
    <KonsolAuth0Provider>
      <PermissionProvider permissions={permissions}>
        <AbortControllerProvider>
          <KonsolSnackbarProvider>
            <App
                setPermissions={setPermissions}
            />
          </KonsolSnackbarProvider>
        </AbortControllerProvider>
      </PermissionProvider>
    </KonsolAuth0Provider>
  );
}